import { Params } from '@angular/router';
import { FILTERS } from '../configs/filters/filters';
import {
  ACTIVE_SORT_HTTP_PARAM_NAMES,
  ActiveSort,
  CheckboxValueType,
  FilterMenuConfig,
  FilterType,
} from '../types/filter.type';

const RANGE_MIN_SUFFIX: string = 'Min';
const RANGE_MAX_SUFFIX: string = 'Max';

export function getFilterParamName(column: string, filterIndex: number): string {
  return filterIndex === 0 ? column : `${column}${filterIndex}`;
}

export function getRangeParamNames(paramName: string): { min: string; max: string } {
  return {
    min: `${paramName}${RANGE_MIN_SUFFIX}`,
    max: `${paramName}${RANGE_MAX_SUFFIX}`,
  };
}

export function getActiveFilterValues(data: CheckboxValueType[]): string[] {
  return data
    .filter((value: CheckboxValueType) => value.isActive === true)
    .map((value: CheckboxValueType) => value.value);
}

export function getFilterQueryParams(
  filters: Record<string, FilterMenuConfig>,
  activeSort: ActiveSort | undefined,
  pendingActiveValues: Record<string, string[]> = {},
): Params {
  const filterParams: Params = Object.entries(filters).reduce(
    (params: Params, [column, config]: [string, FilterMenuConfig]) => {
      config.filters.forEach((filter: FilterType, index: number) => {
        Object.assign(params, getFilterParams(column, index, filter, pendingActiveValues[column]));
      });

      return params;
    },
    {},
  );

  if (!activeSort) return filterParams;

  return {
    ...filterParams,
    [ACTIVE_SORT_HTTP_PARAM_NAMES.sortType]: activeSort.sortType,
    [ACTIVE_SORT_HTTP_PARAM_NAMES.sortDirection]: activeSort.sortDirection,
  };
}

function getFilterParams(
  column: string,
  filterIndex: number,
  filter: FilterType,
  pendingValues: string[] | undefined,
): Params {
  const paramName: string = getFilterParamName(column, filterIndex);
  const defaultFilter: FilterType | undefined = FILTERS[column]?.filters[filterIndex];

  switch (filter.type) {
    case 'checkbox':
    case 'radio': {
      const values: string[] = getActiveFilterValues(filter.data);
      const advertisedValues: string[] = values.length > 0 ? values : (pendingValues ?? []);

      return advertisedValues.length > 0 ? { [paramName]: advertisedValues } : {};
    }
    case 'range': {
      const { min, max } = getRangeParamNames(paramName);
      const defaultRange: FilterType | undefined =
        defaultFilter?.type === 'range' ? defaultFilter : undefined;

      return {
        ...(filter.min !== defaultRange?.min ? { [min]: filter.min } : {}),
        ...(filter.max !== defaultRange?.max ? { [max]: filter.max } : {}),
      };
    }
    case 'search':
      return filter.value ? { [paramName]: filter.value } : {};
  }
}
